import type { ResourceName } from '@domain/types/entity';

export const isEndorsement = (resourceName?: ResourceName) => resourceName?.startsWith('submissions#');
